import InfoChit from '@/components/chit/InfoChit';
import { displayPurchaseOrderState } from '@/services/purchaseOrders/displayPurchaseOrderState';
import { PoStatus } from '@/services/purchaseOrders/usePurchaseOrderService';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  status: PoStatus;
  className?: string;
}

export const PurchaseOrderStatusChit: FC<Props> = ({ status, className }) => {
  return (
    <InfoChit className={twMerge(className, 'w-fit')} type={status === PoStatus.Complete ? 'blue' : 'orange'}>
      {displayPurchaseOrderState(status)}
    </InfoChit>
  );
};
